/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-bluetooth': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 18.75a.625.625 0 01-.625-.625v-6.619l-4.119 4.119-.881-.881L9.119 10 4.375 5.256l.881-.881 4.119 4.119V1.875a.625.625 0 011.031-.475l4.375 3.75a.625.625 0 01.219.475.625.625 0 01-.181.469L10.88 10l3.938 3.931a.625.625 0 01.181.444.625.625 0 01-.219.45l-4.375 3.75a.625.625 0 01-.406.175zm.625-7.244v5.263l2.831-2.431-2.831-2.832zm0-8.275v5.263l2.831-2.832-2.831-2.43z"/>'
  }
})
